import { createContext } from 'react';

interface IAuthToken {
  accessToken: string;
  refreshToken: string;
}

interface IAuthContext {
  token: IAuthToken;
  setToken: (token: any) => void;
  removeToken: () => void;
}

export const AuthContext = createContext<IAuthContext>({} as any);
